module.exports = __webpack_public_path__ + "static/media/09.07f15fa8.jpg";